import { IProcessedStyleSet, PrimaryButton } from '@fluentui/react';
import * as React from 'react';
import { AutomationIds } from '../../../../models/constants/automationIds';
import { ISubwayNavNodeStyles } from '../../controls/SubwayNav';
import { RequestStepsSchema } from '../../models/requestModels';
import {
  getChatButtonStyles,
  getSubwayNavClassNames,
  getSubwayNavStepStyles,
  IRequestSectionStyles,
} from '../../styles/requestDetailsStyles';
import { IThemedProp } from '../../styles/themesUI';

type stepProps = {
  data: RequestStepsSchema;
  subwayNavClassNames: IProcessedStyleSet<ISubwayNavNodeStyles>;
  themedClassNames: IProcessedStyleSet<IRequestSectionStyles>;
  onChatButtonClick?: () => void;
  statusMessage?: string;
};

export type IRequestStepProps = stepProps & IThemedProp;
export const RequestStep: React.FunctionComponent<IRequestStepProps> = (
  props: IRequestStepProps
) => {
  const classNames = getSubwayNavClassNames(getSubwayNavStepStyles, {
    theme: props.theme,
  });
  return (
    <div
      className={`${props.subwayNavClassNames.labelWrapper} ${props.themedClassNames.requestSteps}`}
    >
      {!props.data!.Active && (
        <div className={`${classNames.hiddenLabel}`}>{props.statusMessage}</div>
      )}
      <div className={props.subwayNavClassNames.label}>{props.data!.Title}</div>
      <div
        className={props.subwayNavClassNames.labelSelected}
        aria-hidden={true}
      >
        {props.data!.Title}
      </div>
      {!!props.data!.IsStepInProcess && (
        <div className={classNames.captionRoot}>
          <div className={classNames.caption}>{props.data!.Date}</div>
          <div>
            <span>{props.data!.ContentText}</span>
            {props.onChatButtonClick && (
              <div className={classNames.button}>
                <PrimaryButton
                  id="RequestStepStartChat"
                  styles={getChatButtonStyles(props)}
                  data-automation-id={AutomationIds.RequestStatusChatBtn}
                  text={props.data!.ContentSubText}
                  onClick={props.onChatButtonClick}
                  target="_blank"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
